import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import i18n from "./plugins/i18n";
import {AuthRequests} from "@/helpers";

const About = () => import("@/views/footerViews/About.vue");
const Cellars = () => import("@/views/Cellars.vue");
const Cellar = () => import("@/views/Cellar.vue");
const CookiesPolicy = () => import("@/views/footerViews/CookiesPolicy.vue");
const Contacts = () => import("@/views/footerViews/Contacts.vue");
const Experiences = () => import("@/views/Experiences.vue");
const Experience = () => import("@/views/Experience.vue");
const BookingSummary = () => import("@/views/booking/BookingSummary.vue");
const Help = () => import("@/views/footerViews/Help.vue");
const Terms = () => import("@/views/footerViews/Terms.vue");
const ResetPassword = () => import("@/views/ResetPassword.vue");
const Home = () => import("@/views/Home.vue");
const NotFoundPage = () => import("@/views/NotFoundPage.vue");
const NotAuthorizedPage = () => import("@/views/NotAuthorizedPage.vue");
const SuccessPayment = () => import("@/views/booking/SuccessPayment.vue");
const Profile = () => import("@/views/Profile.vue");

Vue.use(Router);
export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      name: "notFoundPage",
      component: NotFoundPage
    },
    {
      path: "/edit-password",
      name: "resetPassword",
      component: ResetPassword,
      alias: ["/en/edit-password"]
    },
    {
      path: "/",
      name: "home",
      component: Home,
      alias: ["/en", "/en/home"]
    },
    {
      path: "/cantina/:id",
      name: "cellar",
      component: Cellar,
      alias: ["/en/cellar/:id"]
    },
    {
      path: "/cantine",
      name: "cellars",
      component: Cellars,
      alias: ["/en/cellars"]
    },
    /*{
      path: "/chi-siamo",
      name: "about", 
      component: About,
      alias: ["/en/about"]
    },*/
    {
      path: "/aiuto",
      name: "help",
      component: Help,
      alias: ["/en/help"]
    },
     {
       path: "/contatti",
       name: "contacts",
     component: Contacts,
      alias: ["/en/contacts"]
     },
    {
      path: "/termini-condizioni",
      name: "terms",
      component: Terms,
      alias: ["/en/terms"]
    },
    {
      path: "/privacy",
      name: "privacy",
      component: CookiesPolicy,
      alias: ["/en/privacy"]
    },
    {
      path: "/esperienza/:id",
      name: "experience",
      component: Experience,
      alias: ["/en/experience/:id"]
    },
    {
      path: "/esperienze",
      name: "experiences",
      component: Experiences,
      alias: ["/en/experiences"]
    },
    {
      path: "/riepilogo-prenotazione",
      name: "bookingSummary",
      component: BookingSummary,
      alias: ["/en/booking-summary"]
    },
    {
      path: "/not-authorized",
      name: "notAuthorized",
      component: NotAuthorizedPage,
      alias: ["/en/notAuthorized"]
    },
    {
      path: "/profilo",
      name: "profile",
      meta: {
        requiresAuth: true
      },
      component: Profile,
      alias: ["/en/profile"]
    },
    {
      path: "/pagina-privata",
      name: "privatePage",
      meta: {
        requiresAuth: true
      },
      component: CookiesPolicy,
      alias: ["/en/private-page"]
    },
    {
      path: "/pagamento-ok",
      name: "paymentOk",
      component: SuccessPayment,
      alias: ["/en/payment-ok"]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const forceQueryCopy = (interesting: string[]) => {
    const hasAllParams = interesting.reduce((hasAllParams, param): boolean => {
      if (from.query[param]) return ((hasAllParams != null) && to.query[param] != null) as boolean;
      else return hasAllParams;
    }, true);
    if (hasAllParams) return;

    const query = interesting.reduce((query, param) => {
      if (from.query[param] && !to.query[param]) {
        if (to.path === from.path) return query;
        query = {...query, [param]: from.query[param] };
      }
      return query;
    }, to.query as any || {});
    if (to.path === from.path || Object.keys(query || {}).length === 0) return;
    return next({ path: to.path, query });
  }

  forceQueryCopy(['ref', 'tap_test']);

  // current language check
  const lang = to.path.split("/")[1];
  if (["en", "it"].includes(lang)) {
    if (i18n.locale !== lang) {
      i18n.locale = lang;
    }
  }
  // not logged in check
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //const { user } = store.state.session;
    const user = AuthRequests.autoAuthUser();
    if (!user) {
      console.log("you are not logged in. redirecting...");
      next("/not-authorized");
    } else {
      console.log("route permission granted");
      next();
    }
  } else {
    // console.warn("sei autorizzato per accedere a questa pagina!");
    next();
  }
});
